import API from "../../../../app/api";
import APIForm from "../../../../app/apiForm";
import config from "../../../../app/config";
import {PATIENT_CONTEXT_TYPE} from '../../../../util/patientContextUtil';
import DictParser from '../../../../util/dictParser';
import _ from 'lodash';
import moment from 'moment';
import {obsTypes} from '../observation/obsUtils';

const getEmails = (currentPatientInWard, type = PATIENT_CONTEXT_TYPE.ED) => {
    let emails = [];
    if (type === PATIENT_CONTEXT_TYPE.EDAU) {
        if(currentPatientInWard?.studies?.edauEcsEmail) {
            emails.push(currentPatientInWard?.studies?.edauEcsEmail)
        }
    } else {
        if(currentPatientInWard?.studies?.ecsEmail) {
            emails.push(currentPatientInWard?.studies?.ecsEmail)
        }

        if(currentPatientInWard?.studies?.discharge?.chadOrCamhs) {
            emails.push(config.safeguardingEmail);
        }
    }


    return emails;
}

export const getECS = async (currentPatientInWard, patientAddData, type, prev, pdf, dischargeCallback) => {
    
    let addData = patientAddData;

    if (addData === null) {
        addData = await API.getPatientAdditionalData(currentPatientInWard.patient.__id);
    }

    let email = getEmails(currentPatientInWard, type);

    let data = await prepareData(currentPatientInWard, addData, pdf);

    // Get Base64 pdf for discharge
    if (dischargeCallback) {
        saveEcs(data, currentPatientInWard.patient.__id, email); // Save cas card to Unity Store
        return getECSPdf(data, dischargeCallback);
    } else {
        if (data)
            return prev ? getECSPdf(data) : saveEcs(data, currentPatientInWard.patient.__id, email);
        else
            return data;
    }
};

export const getECSById = async (currentPatientInWard) => {
    let addData = await API.getPatientAdditionalData(currentPatientInWard.patient.__id);
    let data = await prepareData(currentPatientInWard, addData);
    let email = [];

    if(data) {
        return saveEcs(data, currentPatientInWard.patient.__id, email);
    }
    else
        return data;
};

export const getECSToEdeu = async (currentPatientInWard) => {
    let addData = await API.getPatientAdditionalData(currentPatientInWard.patient.__id);
    let email = getEmails(currentPatientInWard);
    let data = await prepareData(currentPatientInWard, addData);

    if(data) {
        return saveEcs(data, currentPatientInWard.patient.__id, email);
    }
    else
        return data;
};

export const prepareData = async (currentPatientInWard, patientAddData, pdf) => {
    let gp = {};
    let surgery = {};

    if (!currentPatientInWard) return false

    let addData = patientAddData;
    if (addData === null) {
        addData = await API.getPatientAdditionalData(currentPatientInWard.patient.__id);
    }

    try {
        if(currentPatientInWard?.patient?.gp) {
            gp = await API.getGpDetails(currentPatientInWard.patient.gp);
        }

        if(currentPatientInWard?.patient?.surgery) {
            surgery = await API.getSurgeryDetails(currentPatientInWard.patient.surgery);
        }

        const age = moment.duration(moment(currentPatientInWard?.admission?.startDate).diff(moment(currentPatientInWard?.patient?.dob))).asYears();
        let resultObs = await API.getFullObservations(currentPatientInWard, age >= 18 ? obsTypes.news : obsTypes.pews)
        let resultObsNeuro = await API.getFullObservations(currentPatientInWard, obsTypes.neuro)
        let resultNotes = await API.getClinicalNotesHis(currentPatientInWard.patient.__id, currentPatientInWard.__id);

        let attendHis = await  API.getPatientAttendancesHistory(currentPatientInWard.patient.__id);


        let chiefComplaintDict = await API.getDictByURL(`/$dict/EcdsChiefOfComplaint`);

        let findClerking = _.find(chiefComplaintDict.__data, {snomedCode: currentPatientInWard?.clerking?.chiefComplaint?.snomedCode});
        let findSeeAndTreat = _.find(chiefComplaintDict.__data, {snomedCode: currentPatientInWard?.studies?.seeAndTreat?.chiefComplaint?.snomedCode});
        let findTriage = _.find(chiefComplaintDict.__data, {snomedCode: currentPatientInWard?.triage?.chiefComplaint?.snomedCode});
        let findAdmission = _.find(chiefComplaintDict.__data, {snomedCode: currentPatientInWard?.admission?.initialAEComplaintSnomedCode});

        let ccClerking =  DictParser.chiefComplaint(findClerking, false);
        let ccSeeAndTreat =  DictParser.chiefComplaint(findSeeAndTreat, false);
        let ccTriage =  DictParser.chiefComplaint(findTriage, false);
        let ccOnAdmission =  DictParser.chiefComplaint(findAdmission, false);

        return {
            patientInWard: currentPatientInWard,
            additionalData: addData,
            gp: gp.data,
            surgery: surgery,
            obs: [...resultObs, ...resultObsNeuro],
            extendedBPValue: config?.observations?.extendedBPValue,
            notes: resultNotes,
            attendHis: attendHis,
            template: pdf,
            chiefComplaintClerking: ccClerking,
            chiefComplaintSeeAndTreat: ccSeeAndTreat,
            chiefComplaintTriage: ccTriage,
            chiefComplaintOnAdmission: ccOnAdmission,

        }
    } catch (e){
        console.error(e);
        return false;
    }

};

const getECSPdf = (data, dischargeCallback) => {
    const openBlob = async (blobT) => {
        let blob = new Blob([blobT], {type: "application/pdf"});
        let objectURL = window.URL.createObjectURL(blob);
        if (!dischargeCallback) window.open(objectURL, "_blank");

        const reader = new FileReader();
        if (dischargeCallback) {
            reader.readAsDataURL(blob);
            reader.onload = dischargeCallback;
        }
    };

    return APIForm.getFormPdf({data: data})
        .then((response) => {
                if (response) {
                    openBlob(response)
                    return true;
                } else
                    return false;
            },
            (er) => {
                return false;
            },
        );
};

const saveEcs = (data, patientId, email) => {
    return  APIForm.getSaveForm( {data: {...data, emailToSend: email}} , patientId)
        .then((response)=>{
                return !!response;
            },
            (er)=> {
                return false
            }
        );
}

